import { render, staticRenderFns } from "./InstallList.vue?vue&type=template&id=108a67e2&scoped=true"
import script from "./InstallList.vue?vue&type=script&lang=js"
export * from "./InstallList.vue?vue&type=script&lang=js"
import style0 from "./InstallList.vue?vue&type=style&index=0&id=108a67e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a67e2",
  null
  
)

export default component.exports